import {
  fetchLocationsRequest,
  fetchLocationsSuccess,
  fetchLocationsFailure
} from '../locations/locationsActionCreator';
import { getLocations } from '../../services/locations';

export async function fetchLocations(dispatch: Function, queryParams: any) {
  dispatch(fetchLocationsRequest());
  try {
    const { data, metadata } = await getLocations(queryParams)
    dispatch(fetchLocationsSuccess(data, metadata));
  } catch (error: any) {
    dispatch(fetchLocationsFailure(error));
  }
}
